import { Component, Input, Output, EventEmitter, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-globalelement-confirm-popup',
  templateUrl: './globalelement-confirm-popup.component.html',
  styleUrls: ['./globalelement-confirm-popup.component.scss']
})
export class GlobalelementConfirmPopupComponent implements OnInit {
 

  isVisible: boolean = true;

  constructor( public dialogRef: MatDialogRef<GlobalelementConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
 

}
